import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { format } from "date-fns";
import VenueCard from "../../components/shared/card/venue/VenueCard";
import { base_URL } from "../../config/config";

const BlogList = () => {
	const [blogs, setBlogs] = useState([]);
	const navigate = useNavigate();

	useEffect(() => {
		const fetchBlogs = async () => {
			try {
				const res = await axios.get(
					`${base_URL}/api/blogs/getBlogs?filter=${JSON.stringify({
						criteria: [{ key: "status", value: "published", type: "eq" }],
					})}`
				);
				const sorted = res.data.data.sort(
					(a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
				);
				setBlogs(sorted);
			} catch (error) {
				console.error("Failed to fetch blogs:", error);
			}
		};

		fetchBlogs();
	}, []);

	return (
		<div className="max-w-6xl mx-auto px-4 py-10">
			<h1 className="text-3xl font-bold mb-8 text-center">
				The latest from the blog
			</h1>
			<div className="grid sm:grid-cols-2 md:grid-cols-3 gap-8">
				{blogs.length > 0 ? (
					blogs
						.filter((blog) => blog.status === "published")
						.map((item) => (
							<VenueCard
								className="!max-h-[320px] !min-h-[320px]"
								onClick={(e) => {
									e.preventDefault();
									navigate(`/blogs/${item.slug}`, {
										state: { blogId: item?._id },
									});
								}}
							>
								<VenueCard.Slider
									className="!h-[180px]"
									images={[item.heroImageUrl]}
									isCardVisible={true}
								></VenueCard.Slider>
								<VenueCard.Details>
									<p className="text-[18px] font-medium leading-snug mt-3 text-gray-700 line-clamp-2 break-words">
										{item?.title}
									</p>
									<div className="flex-1 flex flex-col justify-end">
										<p className="text-gray-500 text-md">
											{format(new Date(item?.updatedAt), "MMMM d, yyyy")}
										</p>
									</div>
								</VenueCard.Details>
							</VenueCard>
						))
				) : (
					<p className="text-gray-500 col-span-full text-center">
						No blogs available yet.
					</p>
				)}
			</div>
		</div>
	);
};

export default BlogList;
